import _DTO from "./_DTO";


export default class SlottedAdditionalDeviceDTO extends _DTO {

  constructor(slottedAdditionalDevice) {
    super();
    this.layer = slottedAdditionalDevice.layer;
    this.selectedDeviceId = slottedAdditionalDevice.selectedDeviceId;
  }

}
